import { CardContent as MuiCardContent, Card as MuiCard, Typography, Box, Button, Fade } from "@material-ui/core";
import styled from "styled-components/macro";
import DoughnutChart from "./components/DoughnutChart";
import TableStats from "./components/TableStats";
import React, { FC } from "react";
import NoDataAvailable from "./components/NoDataAvailable";
import Loading from "./components/Loading";
import { useTranslation } from "react-i18next";
import ButtonLink from "../ButtonLink";

const Card = styled(MuiCard)`
  border-radius: 14px
`;
const CardContent = styled(MuiCardContent)`
  padding: 0;
  position: relative;
  &:last-child {
    padding-bottom: 0
  }
`;

const ButtonWrapper = styled.div`
  padding: 0 16px;
  margin-bottom: 16px;

`

type PropsType = {
  data: {completed: number | null, notCompleted: number | null}
}

const TotalAmountOfProperties:FC<PropsType> = ({data}) => {
  const { t } = useTranslation();
  const {completed, notCompleted} = data

  const loading = !notCompleted && notCompleted !== 0 &&
    !notCompleted && notCompleted !== 0

  const haveData = () => {
    const completedStatus = completed && completed !== 0
    const notCompletedStatus = notCompleted && notCompleted !== 0
    return completedStatus || notCompletedStatus
  }

  const getPercent = () => {
    if (completed !== null && notCompleted !== null) {
      const calculate = Math.round((completed / (completed + notCompleted)) * 100)
      return isNaN(calculate) ? 0 : calculate
    }
    return 0
  }

  const tableData = {
    heads: [
      t("statsPage_amountCompleted"),
      ''
    ],
    rows: [{
      value: completed,
      percent: getPercent() + '%'
    }]
  }

  const doughnutData = {
    labels: [
      t("statsPage_completed"),
      t("statsPage_notCompleted")
    ],
    data: [
      completed ? completed : 0,
      notCompleted ? notCompleted : 0
    ]
  }
  return (
    <Fade in={true}>
      <Card>
        <CardContent>
          <Box p={4}>
            <Typography>
              {t("statsPage_totalAmountProperties")}
            </Typography>
          </Box>
          <Loading loading={loading} height={261}>
            <Box>
              <Box mt={5} mb={9}>
                <DoughnutChart
                  labels={doughnutData.labels}
                  data={doughnutData.data}
                />
              </Box>
              <TableStats
                headNames={tableData.heads}
                rows={tableData.rows}
              />
              {/*padding: 0 16px */}
              <ButtonWrapper>
                <ButtonLink
                  to={'/standards'}
                  text={'Improve your properties data'}
                />
              </ButtonWrapper>
              <NoDataAvailable visible={!haveData()}/>
            </Box>
          </Loading>
        </CardContent>
      </Card>
    </Fade>
  )
}
export default TotalAmountOfProperties
